/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ListFigureUnit } from './listFigureUnit';
import type { Item } from './item';
import type { Extras } from './extras';

export interface ListFigure {
  name: string;
  shape: 'list';
  unit: ListFigureUnit;
  value: Item[];
  extras: Extras;
}
